import { combineReducers } from '@reduxjs/toolkit';
import receivers, { ReceiverListState } from './ReceiverReducer';
import receiverImport, { ReceiverImportState } from './ReceiverImportReducer';

export type ReceiverState = { receivers: ReceiverListState; receiverImport: ReceiverImportState };

const ReceiverReducer = combineReducers({
  receivers,
  receiverImport,
});

export default ReceiverReducer;
